import React from 'react'
import ReactDOM from 'react-dom'
import { applyMiddleware, compose, createStore /*,combineReducers*/ } from 'redux'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'

import App from './app/App.js'
import registerServiceWorker from './registerServiceWorker'
import reducer from './store/reducers/reducer'
import constants from '../src/resource/constants.js'
import { AthenaGlobalFooter, AthenaGlobalHeader } from './components/common/AthenaWidgets.js'

//use this when there are more than one reducer
// const rootReducer = combineReducers({
//   reducer1,
//   reducer2
// })

//middleware
const logger = store => {
    return next => {
        return action => {
            //console.log('[Middleware] Dispatching', action)
            const result = next(action)
            //console.log('[Middleware] next state', store.getState())
            return result
        }
    }
}

//dev tools support for redux
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(reducer, composeEnhancers(applyMiddleware(logger, thunk)))

ReactDOM.render(
  <Provider store={store}>
    <AthenaGlobalHeader />
    <App appId={constants.app_id} />
    <AthenaGlobalFooter />
  </Provider>,
  document.getElementById("root")
)
registerServiceWorker()
